export default {
    'tomatometer': '¿Qué es el Tomatómetro ® ? ',
    'coming-soon': 'Próximamente',
    'on-screen': 'En cines ahora',
    'disembark': 'Iniciar sesión',
    'sign-in': 'Registrarse',
    'please-email-address': 'Email',
    'please-enter-the-user-password': 'Contraseña',
    'privacy-policy': 'Política de Privacidad',
    'terms-and-conditions': 'Términos y políticas',
    'about-us': 'SÍGUENOS',
    'all-rights-reserved': 'Todos los derechos reservados',
    'assist': 'Ayuda',
    'contact-us': 'SÍGANOS',
    'cookie-notification': 'Aviso de cookies',
    'permission': 'Licencia',
    'film-type': 'Género',
    'source-language': 'Idioma origina',
    'director': 'Director',
    'producer': 'Productor',
    'writer': 'Escritor',
    'release-date': 'Fecha de estreno',
    'running-time': 'Tiempo de ejecución',
    'publisher': 'Distribuidor',
    'plot-introduction': 'INFORMACIÓN DE LA PELÍCULA',
    'cast-member': 'REPARTO',
    'desired-number-of-viewers': 'Número de personas que quieren mirar',
    'buy': 'Compra',
    'purchase-quantity': 'Cantidad de compra',
    'ok': 'Confirmar',
    'cancel': 'Cancelación',
    'user-information': 'Información del usuario',
    'my-wallet': 'Mi Billetera',
    'log-out': 'Cerrar sesión',
    'user-name': 'Nombre del titular de la cuenta',
    'bank-card-number': 'Número de tarjeta bancaria',
    'bank-name': 'Nombre del banco',
    'edit-user-information': 'Editar información de usuario',
    'please-enter-the-user-name': 'Por favor, introduzca el nombre de usuario',
    'please-enter-your-bank-card-number': 'Por favor, introduzca el número de tarjeta bancaria',
    'please-enter-the-bank-name': 'Por favor, introduzca el nombre del banco',
    'wallet-information': 'Información de la billetera',
    'top-up': 'Recarga',
    'enter-the-recharge-amount': 'Ingrese el monto de recarga',
    'please-enter-the-recharge-amount': 'Ingrese el monto de recarga',
    'dailymaximum': 'Límite máximo diario 99999999',
    'submit-top-up': 'Enviar recarga',
    'withdraw': 'Retiro',
    'please-enter-the-withdrawal-amount': 'Ingrese el monto de retiro',
    'submissionofwithdrawal': 'Enviar retiro',
    'walletflow': 'Historial de la billetera',
    'variablelimits': 'monto de cambio',
    'variablelimit': 'Monto después del cambio',
    'type': 'Tipo',
    'status': 'estado',
    'time': 'tiempo',
    'nodataavailable': 'No hay datos disponibles',
    'systemvariation': 'Cambios en el sistema',
    'ticketrefusal': 'Compra de boletos rechazada',
    'withdrawalrefusal': 'Retiro rechazado',
    'recharge': 'Recarga (Rechazo de revisión)',
    'withdrawalthrough': 'Retiro aprobado',
    'ticketapproval': 'Compra de boletos aprobada',
    'augment': 'Aumentar',
    'decrease': 'Disminuir',
    'movieticketflow': 'Historial de entradas de cine',
    'movieticketname': 'nombre de la entrada de cine',
    'purchasequantity': 'Cantidad comprada',
    'purchasetime': 'Hora de compra',
    'successfulissue': 'Emisión de boletos exitosa',
    'issuefailure': 'Emisión de boletos fallida',
    'currentintegral': 'Puntos actuales',
    'manufacturingcompany': 'Compañía de producción',
    'enterwithdrawalamount': 'Ingrese el monto de retiro',
    'iniCode': 'Introduzca el código de invitación',
    'zhanghu': 'saldo de la cuenta',
    'xiangkan': 'Número de espectadores',
    'goumai': 'Comprar entradas',
    'baochang': 'Reservar',
    'nobaochang': 'No reservado',
    'qukuan': 'Ingrese el monto de retiro',
    'shouye': 'Tamatómetro',
    'me': 'mi',
    'movieDetail': 'Detalles de la película',
    'center': 'centro personal',
    'loginf': 'Iniciar sesión',
    'register': 'Registrarse',
    'account': 'Saldo de la cuenta',
    'change': 'Importe antes del cambio',
    'changeafter': 'Monto después del cambio',
    'types': 'Tipo',
    'statuss': 'estado',
    'times': 'Tiempo',
    'success': 'En espera de revisión',
    'price': 'Introduzca el importe',
    'yuan': 'MXN',
    'comfirmPas': 'Repita  contraseña',
    'privacy1': 'Acepto los términos de ofertas públicas y he leído la',
    'privacy2': 'Política de privacidad y datos personales',
    'match': 'Dos contraseñas no coinciden',
    'google': 'Inicia sesión con Google',
    'loginErr': 'Por favor inicia sesión para operar',
    'error': 'Excepción de red, por favor inténtelo de nuevo',
    'customer': 'Atendimento ao cliente',
    'erc20': 'ERC20',
    'trc20': 'TRC20',
    'copy': 'Um clique para copiar',
    'points': 'Pontos de reputação',

};



// WEBPACK FOOTER //
// ./src/lang/pt.js